import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as departmentActions from '../../Redux/Actions/department';
import * as masterProcessActions from '../../Redux/Actions/masterProcess';
import * as processActions from '../../Redux/Actions/process';
import * as processCosts from '../../Redux/Actions/processCost';
import {toastMessage} from '../../utils/toast';
import { getParams } from '../../utils';
import { useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';
import MasterInfo from './info';

const UpdateMaster = ({match, history}) => {

    let params = getParams(window.location.search);
    let masterID = parseInt(params.masterID);
    let {type: masterType} = match.params;
    let typeName = masterType.includes('department') ? 'Department' : (masterType.includes('master') ? 'Master Process' : 'Process');
    const { t } = useTranslation();

    let dropDownType = masterType.includes('department') ? '' : (masterType.includes('master') ? 'department' : masterType.includes('process') ? 'master-process' : '');
    let dropDownID = (masterType.includes('master') ? 'departmentId' : masterType.includes('process') ? 'masterProcessId' : '');
    const [loading, setLoading] = useState(false);
    const [dropDownData, setDropDownData] = useState([]);
    const [dropDownValue, setDropDownValue] = useState('');
    const [processCostData, setProcessCostData] = useState([]);
    const [processCostValue, setProcessCostValue] = useState('');
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [arabicName, setArabicName] = useState('');
    const [arabicDescription, setArabicDescription] = useState('');
    const [icon, setIcon] = useState();
    const [buttonLoading, setButtonLoading] = useState(false);
    const [isEnable, setIsEnable] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        setLoading(true);
        let getType = masterType.includes('department') ? departmentActions : (masterType.includes('master') ? masterProcessActions : processActions);
        getType.getIndividual(masterID).then(res => {
            if(res && res.data){
                let data = res.data;
                setName(data.name);
                // setDropDownValue(data?.department?.name);
                if(masterType === 'process') {
                    setDropDownValue(data?.masterProcess?.name);
                } else {
                    setDropDownValue(data?.department?.name);
                }
                setDescription(data.description);
                setArabicName(data.arabicName);
                setArabicDescription(data.arabicDescription);
                setIcon(data.icon);
                setIsEnable(data?.isEnable);

                let dropDownApiType = masterType.includes('department') ? '' : (masterType.includes('master') ? departmentActions : masterType.includes('process') ? masterProcessActions : '');
                (dropDownApiType !== '') && dropDownApiType.getAll().then(res => {
                    if(res && res.data){
                        setDropDownData(res.data);
                        // let dropDownData = res.data.filter(({id}) => id === data[dropDownID])[0];
                        // console.log(dropDownData);
                        // setDropDownValue((masterID && dropDownData && dropDownData.length !== 0) ? dropDownData && dropDownData.name : '');
                    }else{
                        setDropDownData([]);
                        toastMessage('error', (res && res.message) || `Unable to load the ${typeName}`);
                    }
                });

                (typeName === 'Process') && masterType.includes('process') && processCosts.getAll().then(res => {
                    if(res && res.data){
                        setProcessCostData(res.data);
                        let existingProcessCostData = res.data.filter(({id}) => id === data.processCostId)[0];
                        setProcessCostValue((existingProcessCostData && existingProcessCostData.length !== 0) ? existingProcessCostData && existingProcessCostData.name : '');
                    }else{
                        toastMessage('error', 'Unable to get the process costs');
                    }
                });
            }else{
                toastMessage('error', (res && res.message) || 'Unable to get the info');
            }
            setLoading(false);
        }).catch(err => {
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [masterID, masterType, dropDownID, masterID, dropDownType]);


    const handleUpdateMaster = () => {
        setButtonLoading(true);
        if((name !== '') && (description !== '')){
            let payload = {
                id: masterID, name, description
            };
            payload = masterType.includes('department') ? {...payload, icon} : {...payload, [dropDownID]: dropDownData && dropDownData.filter(({name}) => name === dropDownValue)[0]?.id};
            payload = (typeName === 'Process') ? {...payload, processCostId: processCostData && processCostData.filter(({name}) => name === processCostValue)[0]?.id} : payload;
            
            if(['Master Process', 'Process'].includes(typeName)) {
                payload['isEnable'] = isEnable;
            }

            let type = masterType.includes('department') ? departmentActions : (masterType.includes('master') ? masterProcessActions : masterType.includes('process') ? processActions : '');
            (type !== '') && type.update(payload).then(res => {
                if(res && res.data){
                    toastMessage('success', `${typeName} updated successfully`);
                }else{
                    toastMessage('error', `${typeName} update failed`);
                }
                setButtonLoading(false);
            }).catch(err => {
                (err.response.status === 401) && clearSession(dispatch, history);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct ${masterType} details`);
        }
    }

    return(
        <>
            <div className="container-fluid">
                <div className="my-4">
                    <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push(`/master/manage/${masterType}`)}>{t(`mastersManagement.${masterType}.update`)}</span>
                    <span className="card-label font-weight-bolder mx-2">/</span>
                    <span className="card-label font-weight-bolder text-dark">{name}</span>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-stretch">
                            <div className="card-header border-0 py-2">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label font-weight-bolder text-dark">{t(`mastersManagement.${masterType}.updateTitle`)}</span>
                                </h3>
                            </div>
                            {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center'}} />
                            : <div className="card-body pt-0 pb-3">
                                {(dropDownType !== '') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t(`mastersManagement.${dropDownType}.dropDown`)}</label>
                                    <select className="form-select me-3" value={dropDownValue} onChange={e => setDropDownValue(e.target.value)}>
                                        <option value="" disabled={true}>{t(`mastersManagement.${dropDownType}.dropDownPlaceholder`)}</option>
                                        {dropDownData && dropDownData.map(({name, id}) => <option key={id} value={name}>{name}</option>)}
                                    </select>
                                </div>}
                                {(masterType === 'process') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.processCost")}</label>
                                    <select className="form-select me-3" value={processCostValue} onChange={e => setProcessCostValue(e.target.value)}>
                                        <option value="" disabled={true}>{t('mastersManagement.add.processCostPlaceholder')}</option>
                                        {processCostData && processCostData.map(({name, id}) => <option key={id} value={name}>{name}</option>)}
                                    </select>
                                </div>}
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.name")}</label>
                                    <input placeholder={t("mastersManagement.add.namePlaceholder")} type="text" className="form-control"
                                        name="name" value={name} onChange={e => setName(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.arabicName")}</label>
                                    <input placeholder={t("mastersManagement.add.arabicNamePlaceholder")} type="text" className="form-control"
                                        name="arabic name" value={arabicName} onChange={e => setArabicName(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.description")}</label>
                                    <input placeholder={t("mastersManagement.add.descriptionPlaceholder")} type="text" className="form-control"
                                        name="description" value={description} onChange={e => setDescription(e.target.value)} />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.arabicDescription")}</label>
                                    <input placeholder={t("mastersManagement.add.arabicDescriptionPlaceholder")} type="text" className="form-control"
                                        name="arabic description" value={arabicDescription} onChange={e => setArabicDescription(e.target.value)} />
                                </div>
                                {masterType.includes('department') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.icon")}</label>
                                    <input placeholder={t("mastersManagement.add.iconPlaceholder")} type="text" className="form-control"
                                        name="icon" value={icon} onChange={e => setIcon(e.target.value)} />
                                </div>}
                                {['Master Process', 'Process'].includes(typeName) && <div className="form-group fv-plugins-icon-container">
                                    <input type="checkbox" checked={isEnable} onChange={() => setIsEnable(preState => !preState)}/>
                                    <label className="mx-2">{t("mastersManagement.add.isEnableMobileDialer")}</label>
                                </div>}
                                <button disabled={buttonLoading} onClick={handleUpdateMaster} type="button" className="d-flex align-items-center btn btn-primary mb-3">
                                    {t(`mastersManagement.${masterType}.update`)} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                </button>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdateMaster;